/* unplugin-vue-components disabled */import script from "./BookingRoomSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingRoomSelector.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__